import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../api/request';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';
import { getGradingStructureInfo } from '../../api';
import { GradingStructureInfoResponse } from '../../interfaces/type';

interface BaseLoaderProps {
  children: ReactElement;
  gradesAcademicId: number;
  deliveryMode: string | null;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  GradingStructureInfoResponse,
  AxiosResultDefaultError
>();

export function useGradingStructureInfoLoader() {
  return useFetch();
}

export const GradingStructureInfoLoaderConsumer = FetchConsumer;

/**
 * Carga la información de la estructura de calificaciones por AcademicLevelId
 */
export default function GradingStructureInfoLoader({
  children,
  gradesAcademicId,
  deliveryMode,
}: BaseLoaderProps) {
  const request = useCallback(async () => {
    return getGradingStructureInfo(gradesAcademicId, deliveryMode);
  }, [gradesAcademicId, deliveryMode]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ loading, data, error, refresh }) => {
          if (loading) {
            return <Loading className="mx-auto" />;
          } else if (error) {
            return (
              <div className="w-100 d-flex justify-content-center">
                <DisplayError textBody={error.code} retryAction={refresh} />
              </div>
            );
          } else if (data) {
            return children;
          } else {
            return null;
          }
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
